import { useState } from "react";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { api, errMsg, fmtUsd } from "@/lib/api";

export const WithdrawCodeStep = ({ pending, onBack, onConfirmed }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/withdrawals/confirm", { request_id: pending.request_id, code });
      onConfirmed(data);
    } catch (e) {
      toast.error(errMsg(e));
      setCode("");
      setBusy(false);
    }
  };

  const resend = () => api.post("/withdrawals/resend", { request_id: pending.request_id })
    .then(() => toast.success("New code sent")).catch((e) => toast.error(errMsg(e)));

  return (
    <div className="space-y-4" data-testid="withdraw-code-step">
      <div className="flex items-start gap-3 rounded-xl border border-[#212638] bg-[#0F111A] p-3">
        <MailCheck size={18} className="mt-0.5 shrink-0 text-[#F7931A]" />
        <p className="text-xs text-[#94A3B8]">We emailed a 6-digit code to <span className="font-semibold text-[#F8FAFC]" data-testid="withdraw-email-hint">{pending.email_hint}</span> to confirm your <span className="font-mono text-[#F8FAFC]">{fmtUsd(pending.amount)}</span> withdrawal. It expires in 10 minutes.</p>
      </div>
      <div className="flex justify-center">
        <InputOTP maxLength={6} value={code} onChange={setCode} onComplete={() => {}} data-testid="withdraw-code-input">
          <InputOTPGroup>
            {[0, 1, 2, 3, 4, 5].map((i) => <InputOTPSlot key={i} index={i} className="h-12 w-11 border-[#212638] bg-[#0F111A] font-mono text-lg" />)}
          </InputOTPGroup>
        </InputOTP>
      </div>
      <button onClick={confirm} disabled={code.length !== 6 || busy} data-testid="withdraw-confirm-button"
        className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#F7931A] py-3 font-semibold text-[#08090E] transition-colors hover:bg-amber-500 disabled:opacity-50">
        {busy && <Loader2 className="animate-spin" size={16} />} Confirm withdrawal
      </button>
      <div className="flex justify-between text-xs">
        <button onClick={onBack} data-testid="withdraw-code-back-button" className="flex items-center gap-1 text-[#94A3B8] transition-colors hover:text-white"><ArrowLeft size={12} /> Back</button>
        <button onClick={resend} data-testid="withdraw-resend-code-button" className="text-[#F7931A] hover:underline">Resend code</button>
      </div>
    </div>
  );
};
